/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * States for metadata loading and processing lifecycle.
 * Tracks the status of various metadata operations across content types.
 */
export enum MetadataState {
  /**
   * Airing metadata fetch failed.
   */
  AIRING_ERROR = "AIRING_ERROR",

  /**
   * Airing metadata successfully loaded and ready.
   */
  AIRING_READY = "AIRING_READY",

  /**
   * Action list fetch failed.
   */
  ACTION_LIST_ERROR = "ACTION_LIST_ERROR",

  /**
   * Action list successfully loaded and ready.
   */
  ACTION_LIST_READY = "ACTION_LIST_READY",

  /**
   * Action details fetch failed.
   */
  ACTION_DETAILS_ERROR = "ACTION_DETAILS_ERROR",

  /**
   * Action details successfully loaded and ready.
   */
  ACTION_DETAILS_READY = "ACTION_DETAILS_READY",

  /**
   * Delete recording operation failed.
   */
  DELETE_RECORDING_ERROR = "DELETE_RECORDING_ERROR",

  /**
   * Delete recording operation completed successfully.
   */
  DELETE_RECORDING_DONE = "DELETE_RECORDING_DONE",

  /**
   * Initial state - no metadata operation in progress.
   */
  NONE = "NONE",

  /**
   * NDVR last viewed position fetch failed.
   */
  NDVR_LAST_VIEWED_POSITION_ERROR = "NDVR_LAST_VIEWED_POSITION_ERROR",

  /**
   * NDVR last viewed position successfully loaded.
   */
  NDVR_LAST_VIEWED_POSITION_READY = "NDVR_LAST_VIEWED_POSITION_READY",

  /**
   * Metadata is currently being prepared/loaded.
   */
  PREPARING = "PREPARING",

  /**
   * Preview metadata fetch failed.
   */
  PREVIEW_ERROR = "PREVIEW_ERROR",

  /**
   * Preview metadata successfully loaded and ready.
   */
  PREVIEW_READY = "PREVIEW_READY",

  /**
   * Recording action fetch failed.
   */
  RECORDING_ACTION_ERROR = "RECORDING_ACTION_ERROR",

  /**
   * Recording action initial load ready.
   */
  RECORDING_ACTION_INIT_READY = "RECORDING_ACTION_INIT_READY",

  /**
   * Recording action fully loaded and ready.
   */
  RECORDING_ACTION_READY = "RECORDING_ACTION_READY",

  /**
   * Recording preview fetch failed.
   */
  RECORDING_PREVIEW_ERROR = "RECORDING_PREVIEW_ERROR",

  /**
   * Recording preview successfully loaded and ready.
   */
  RECORDING_PREVIEW_READY = "RECORDING_PREVIEW_READY",

  /**
   * VOD action fetch failed.
   */
  VOD_ACTION_ERROR = "VOD_ACTION_ERROR",

  /**
   * VOD action successfully loaded and ready.
   */
  VOD_ACTION_READY = "VOD_ACTION_READY",

  /**
   * VOD preview fetch failed.
   */
  VOD_PREVIEW_ERROR = "VOD_PREVIEW_ERROR",

  /**
   * VOD preview successfully loaded and ready.
   */
  VOD_PREVIEW_READY = "VOD_PREVIEW_READY"
}
